var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.courses.length > 0)?_c('div',{staticClass:"grid"},_vm._l((_vm.courses),function(course){return _c('div',{key:course.id},[_c('v-card',{attrs:{"height":"100%","to":{
					name: 'course',
					params: {
						courseid: course.id,
					}
				},"elevation":"24"}},[_c('v-card-title',[_vm._v(_vm._s(course.name))]),_c('v-card-text',[_c('small',[_vm._v(_vm._s(course.author.name)+" "+_vm._s(course.author.surname))])])],1)],1)}),0):_c('div',{staticClass:"grid"},_vm._l((2),function(i){return _c('div',{key:i},[_c('v-skeleton-loader',{attrs:{"type":"image","height":"100%"}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }